import {Component, Inject} from "@angular/core";
import {FormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {VentanaFlotante} from "../models/VentanaFlotante";
import {Validadores} from "../validadores";
import {HojasCallCenterComponent} from '../hojas-call-center.component';
import {getErrorMessage} from '../helpers/error';
import {BdService} from '../services/bd.service';
import {PrimaService} from "../services/bd/CallCenter/prima.service";

@Component({
  selector: 'ral-colaborador-prima',
  templateUrl: './prima.component.html',
  styleUrls: ['./prima.component.scss']
})
export class PrimaComponent extends VentanaFlotante
{
  protected busquedaForm = this.formBuilder.group({
    matricula: ["", [Validadores.matricula()]],
    poliza: [""],
    claimDate: ["", [Validators.required]],
  });
  protected buscando = false;
  protected poliza = "";
  protected nombre = "";
  protected apellidos = "";
  protected direccion = "";
  protected codigoPostal = "";
  protected localidad = "";
  protected marca = "";
  protected modelo = "";
  protected nif = "";
  protected email = "";
  protected telefonos = ["", ""];
  protected fechaInicioContrato = "";
  protected fechaVencimientoContrato = "";
  protected fechaInicioCobertura = "";
  protected siniestro = "";
  private formularioHojas: HojasCallCenterComponent;

  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: {formularioHojas: HojasCallCenterComponent},
    private formBuilder: FormBuilder,
    private prima: PrimaService,
    private bd: BdService,
  )
  {
    super(dialogRef, data);
    this.formularioHojas = data.formularioHojas;
  }

  async buscar() {
    try {
      const busqueda = this.busquedaForm.value;
      this.buscando = true;
      const polizas = await this.prima.buscarPoliza(this.formularioHojas.token, busqueda.matricula!, busqueda.poliza!, busqueda.claimDate!);
      if (typeof polizas === "string" && polizas === "NotFound") {
        this.formularioHojas.mostrarArgumentario("Matrícula no encontrada / Poliza caducada", ["No se ha podido encontrar esta matrícula o poliza caducada en fecha de siniestro."], false, true, true);
      } else {
        let date = new Date(busqueda.claimDate!);
        this.formularioHojas.asegurado.poliza = polizas.policy_number.toString().trim();
        this.formularioHojas.asegurado.nombre = polizas.policy_holder.full_name.toString().trim();
        this.formularioHojas.asegurado.dni = polizas.policy_holder.document.id.toString().trim();
        this.formularioHojas.vehiculo.matricula = polizas.vehicle_details.plate_number.toString().trim();
        this.formularioHojas.vehiculo.marca = polizas.vehicle_details.maker.toString().trim().toUpperCase();
        this.formularioHojas.modeloSeleccionado = polizas.vehicle_details.model.toString().trim().toUpperCase();
        if(this.formularioHojas.vehiculo.marca != ""){
          this.formularioHojas.cargarModelos(this.formularioHojas.vehiculo.marca);
        }
        if(polizas.windshield_coverage != "COVERED"){
          this.formularioHojas.mostrarArgumentario("Atención", ["Su póliza no cubre cristales."], false, true, true);
        }
        if((date < polizas.start_at || date > polizas.end_at)){
          this.formularioHojas.mostrarArgumentario("Atención", ["La póliza esta caducada."], false, true, true);
        }
        this.onClose();
      }
    } catch (e) {
      this.formularioHojas.mostrarArgumentario("Error al buscar", ["El servidor ha devuelto el siguiente error:", getErrorMessage(e)], false, true, true);
    } finally {
      this.buscando = false;
    }
  }
}
